import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons"
import Icon from "../Icon"

export default ({ pages = 5, currentPage = 1, onPageChange=() => {} }) => {

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const minPage = Math.max(1, currentPage - 2); 
        const maxPage = Math.min(pages, currentPage + 2);
    
        if (minPage > 1) {
          pageNumbers.push(1);
          if (minPage > 2) {
            pageNumbers.push("...");
          }
        }
    
        for (let i = minPage; i <= maxPage; i++) {
          pageNumbers.push(i);
        }
    
        if (maxPage < pages) {
          if (maxPage < pages - 1) {
            pageNumbers.push("...");
          }
          pageNumbers.push(pages);
        }
    
        return pageNumbers;
      };
    

    return (
        <ul className="list-unstyled d-flex gap-2 align-items-center">
            <li className="fs-4 me-3 text-muted" disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}
 >
                <Icon icon={faAngleLeft} />
            </li>
            {
                renderPageNumbers().map((page, index) =>
                    typeof page === "number" ? <li
                        key={index}
                        onClick={() => onPageChange(page)}
                    >
                        <div
                            className={`border rounded-circle d-flex justify-content-center align-items-center text-muted ${ currentPage === page && "text-dark border-dark"}`}
                            style={{
                                width: "30px",
                                height: "30px"
                            }}
                        >
                            {page}
                        </div>
                    </li>
                    :
                    <li>
                        <div
                            className="border rounded-circle d-flex justify-content-center align-items-center text-muted"
                            style={{
                                width: "30px",
                                height: "30px"
                            }}
                        >
                            ...
                        </div>
                    </li>
                )
            }
            <li className="fs-4 ms-3 text-muted" 
                onClick={() => onPageChange(currentPage + 1)}
                // disabled={currentPage === pages}        
            >
                <Icon icon={faAngleRight} />
            </li>
        </ul>
    )

}